import React from 'react';
import _ from 'lodash';
import {Button, useTheme} from '@mui/material'
import {TopNavBarButton} from 'module/TopNavBar/type/TopNavBarButton'
import {css} from '@emotion/react'
import {ButtonProps} from '@mui/material/Button'

export interface TopNavBarButtonProps extends ButtonProps {
	btnDef?: TopNavBarButton
	target?: string // ButtonProps has href, but not target
}

export function TopNavBarButtonComponent({btnDef, ...props}: TopNavBarButtonProps) {
	const theme = useTheme()
	const csButton = css`
		background-color: ${btnDef?.backgroundColor && _.get(theme.palette, btnDef.backgroundColor)?.main || theme.palette.primary.main};
		color: ${btnDef?.color && _.get(theme.palette, btnDef.color) || theme.palette.common.white};
		border-radius: 10px;
		border-color: ${theme.palette.primary.dark};
		text-transform: none;
		padding: ${theme.spacing(0.5, 1)};
		overflow: hidden;

		:hover {
			background-color: ${btnDef?.backgroundColor && _.get(theme.palette, btnDef.backgroundColor)?.dark || theme.palette.primary.dark}
		}
	`
	return <Button {...props} css={csButton}/>
}